<template>
  <div class="dashboard_warp">
    <!--    <img-->
    <!--      :src="dashboardBg"-->
    <!--      style="width:calc(100% - 0px);height:calc(100vh - 88px)"-->
    <!--    />-->
    <!--    顶部统计图-->
    <div class="dashboard_statistics_picture">
      <!--      会员统计-->
      <div class="dashboard_statistics_picture_item">
        <div class="statistics_picture_item_left">
          <div class="statistics_picture_item_title">
            <img src="@/assets/dashboard/icon_tj.png" />
            <div class="title_warp">会员统计</div>
          </div>
          <div>
            <div ref="myMemberChart" style="width: 100%;height:260px;"></div>
          </div>
        </div>
        <div class="statistics_picture_item_right">
          <div>
            <div class="statistics_picture_item_right_title">
              会员总人数(人)
            </div>
            <div class="statistics_picture_item_right_value">
              {{ memberData.totalCount }}
            </div>
          </div>
          <div style="margin-top: 20px">
            <div class="statistics_picture_item_right_title">今日新增(人)</div>
            <div class="statistics_picture_item_right_value">
              {{ memberData.addCount }}
            </div>
          </div>
        </div>
      </div>
      <!--      订单统计-->
      <div class="dashboard_statistics_picture_item">
        <div class="statistics_picture_item_left">
          <div class="statistics_picture_item_title">
            <img src="@/assets/dashboard/icon_tj.png" />
            <div class="title_warp">订单统计</div>
          </div>
          <div>
            <div ref="myOrderChart" style="width: 100%;height:260px;"></div>
          </div>
        </div>
        <div class="statistics_picture_item_right">
          <div>
            <div class="statistics_picture_item_right_title">今日订单</div>
            <div class="statistics_picture_item_right_value">
              {{ round(orderData.totalCount) }}
            </div>
          </div>
          <div style="margin-top: 20px">
            <div class="statistics_picture_item_right_title">
              今日订单金额(元)
            </div>
            <div class="statistics_picture_item_right_value">
              {{ round(orderData.totalAmount) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    底部卡片统计-->
    <div class="dashboard_card">
      <!--      现金余额(元)-->
      <div
        v-for="(item, key) in balanceData"
        :class="
          (key + 1) % 3 === 0
            ? 'dashboard_card_item'
            : 'dashboard_card_item dashboard_card_item_mar'
        "
        :key="key"
      >
        <div
          class="dashboard_card_item_top"
          :style="{
            background: 'linear-gradient(to bottom, #FFFFFF,' + item.color + ')'
          }"
        >
          <div>
            <div class="dashboard_card_item_top_title">
              <img :src="item.iconUrl ? item.iconUrl : '@/assets/dashboard/icon_xjye.png'" />
              <!--              <div class="title_warp">现金余额(元)</div>-->
              <div class="title_warp">{{ item.name }}</div>
            </div>
            <div class="dashboard_card_item_top_value">
              {{ round(item.curAmount) }}
            </div>
          </div>
          <div class="right_">
            <div class="right_title" v-if="item.rightTitle">
              全网活期账户次数总数
            </div>
            <!--            <div class="right_value right_margin" v-if="item.rightTitle">258</div>-->
            <!--            <div class="right_title right_margin" v-if="item.rightTitle">待结算次数</div>-->
            <!--            <div class="right_value right_margin" v-if="item.rightTitle">258</div>-->
          </div>
        </div>
        <div class="dashboard_card_item_but">
          <div class="dashboard_card_item_but_item">
            <span class="dashboard_card_item_but_title">锁仓</span>
            <span class="dashboard_card_item_but_value _j">
              {{ round(item.lockAmount) }}
            </span>
          </div>

          <div class="dashboard_card_item_but_item">
            <span class="dashboard_card_item_but_title">今日</span>
            <span
              :class="
                item.addAmount >= 0
                  ? 'dashboard_card_item_but_value _j'
                  : 'dashboard_card_item_but_value _jj'
              "
            >
              <span v-if="item.addAmount >= 0">+</span>
              {{ round(item.addAmount) }}
            </span>
          </div>

          <div class="dashboard_card_item_but_item">
            <span class="dashboard_card_item_but_title">同比</span>
            <span
              :class="
                item.rate !== 0
                  ? isPositiveNegativeOrZero(item.rate)
                    ? 'dashboard_card_item_but_value _j'
                    : 'dashboard_card_item_but_value _jj'
                  : 'dashboard_card_item_but_value'
              "
            >
              {{ item.rate }}%
            </span>
            <div v-if="item.rate" style="margin-left: 6px">
              <img
                src="@/assets/dashboard/icon_ts.png"
                v-if="isPositiveNegativeOrZero(item.rate)"
              />
              <img src="@/assets/dashboard/icon_jd.png" v-else />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import defaultSettings from "@/settings";
import echarts from "echarts";
import { getUsersStatis, getOrderStatis, getBalanceStatis } from "@/api/dashboard";
import { isPositiveNegativeOrZero } from "@/utils/index";

export default {
  name: "Dashboard",
  data() {
    return {
      dashboardBg: defaultSettings.dashboardBj,
      dashboardIcon: defaultSettings.dashboardIcon,
      memberData: {
        addCount: 0,
        totalCount: 0
      },
      orderData: {
        totalAmount: 0,
        totalCount: 0
      },
      balanceData: []
    };
  },
  mounted() {
    this.initMemberChart();
    this.initOrderChart();
    this.getBalanceStatis();
  },
  methods: {
    isPositiveNegativeOrZero,
    /**
     * 会员图表
     */
    initMemberChart() {
      var myMemberChart = echarts.init(this.$refs.myMemberChart);
      getUsersStatis().then(resp => {
        const chartOptions = {
          title: {},
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            type: "category",
            data: []
          },
          yAxis: {
            type: "value"
          },
          series: [
            {
              data: [],
              type: "line",
              smooth: true
            }
          ]
        };
        if (resp && resp.bizcode === 100) {
          this.memberData.addCount = resp.data.addCount;
          this.memberData.totalCount = resp.data.totalCount;
          const arrayData = resp.data.dailys.reverse();
          chartOptions.xAxis.data = arrayData.map(item => item.registerDate);
          chartOptions.series[0].data = arrayData.map(item => item.dailyNewUsers);
        } else {
          chartOptions.xAxis.data = [];
          chartOptions.series[0].data = [];
        }
        myMemberChart.setOption(chartOptions); // 使用响应式数据初始化图表
      });
    },
    /**
     * 订单图表
     */
    initOrderChart() {
      var myOrderChart = echarts.init(this.$refs.myOrderChart);
      getOrderStatis().then(resp => {
        const chartOptions = {
          title: {},
          tooltip: {
            trigger: "axis"
          },
          legend: {
            data: ["订单金额", "订单数量"]
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            type: "category",
            data: []
          },
          yAxis: {
            type: "value"
          },
          series: [
            {
              name: "订单金额",
              type: "line",
              stack: "Total",
              data: []
            },
            {
              name: "订单数量",
              type: "line",
              stack: "Total",
              data: []
            }
          ]
        };
        if (resp && resp.bizcode === 100) {
          this.orderData.totalAmount = resp.data.totalAmount;
          this.orderData.totalCount = resp.data.totalCount;
          const arrayData = resp.data.dailys.reverse();
          chartOptions.xAxis.data = arrayData.map(item => item.orderDate);
          chartOptions.series[0].data = arrayData.map(item => item.dailyOrderAmount); //金额
          chartOptions.series[1].data = arrayData.map(item => item.dailyOrderCount); //数量
        } else {
          chartOptions.xAxis.data = [];
          chartOptions.series[0].data = [];
          chartOptions.series[1].data = [];
        }
        myOrderChart.setOption(chartOptions); // 使用响应式数据初始化图表
      });
    },
    // updateChart() {
    //   // 更新图表数据的方法
    //   this.chartOptions.series[0].data = [12, 32, 21, 23]; // 更新数据数组
    //   this.initChart(); // 重新初始化图表以应用更新（实际应用中应使用myChart.setOption更新）
    // }
    /**
     * 查询余额的数据
     */
    getBalanceStatis() {
      getBalanceStatis().then(resp => {
        if (resp && resp.bizcode === 100) {
          const colorArr = ["#F1F7FF", "#FFF5F5", "#FFF5EF", "#FFF5FB", "#FFF5EA", "#FAF3FF"];
          const data = resp.data || [];
          data.map((item, key) => {
            item.color = colorArr[key];
            // const rate = -0.28;
            const rate = item.rate;
            if (rate !== 0) {
              item.rate = (rate * 100).toFixed(2);
            }
            if (item.category === "expend") {
              item.iconUrl = require("@/assets/dashboard/icon_gxz.png");
            }
            if (item.category === "raffle") {
              item.iconUrl = require("@/assets/dashboard/icon_cjcs.png");
              // item.rightTitle = "全网活期账户次数总数";
            }
            if (item.category === "bonus") {
              item.iconUrl = require("@/assets/dashboard/icon_xjyj.png");
              item.rightTitle = "全网活期账户佣金总数";
            }
            if (item.category === "redpacket") {
              item.iconUrl = require("@/assets/dashboard/icon_xjhb.png");
            }
            if (item.category === "balance") {
              item.iconUrl = require("@/assets/dashboard/icon_xjye.png");
            }
            if (item.category === "vcoin") {
              item.iconUrl = defaultSettings.dashboardIcon;
            }
          });
          this.balanceData = data;
        }
      });
    },
    round(val) {
      return Math.round(Number(val) * 100) / 100;
    }
  }
};
</script>

<style lang="scss" scoped>
.dashboard_warp {
  background: #f7f7f7;
  height: calc(100vh - 144px);
  padding: 30px;
  overflow-y: auto;
  .dashboard_statistics_picture {
    display: flex;
    justify-content: space-between;
  }
  .dashboard_statistics_picture_item {
    display: flex;
    justify-content: space-between;
    width: 47%;
    background: #ffffff;
    box-shadow: 0px 1px 6px 0px rgba(204, 204, 204, 0.3);
    border-radius: 10px;
    padding: 30px;
    .statistics_picture_item_title {
      display: flex;
      align-items: center;
      .title_warp {
        font-size: 24px;
        color: #333333;
        margin-left: 10px;
      }
    }
    .statistics_picture_item_left {
      width: 70%;
    }
    .statistics_picture_item_right {
      width: 30%;
      display: grid;
      margin-left: 20px;
      .statistics_picture_item_right_title {
        font-size: 18px;
        color: #000000;
      }
      .statistics_picture_item_right_value {
        background: #f2f4f8;
        border-radius: 5px;
        font-family: DINPro;
        font-weight: bold;
        font-size: 40px;
        color: #111111;
        //text-align: center;
        padding: 10px 0 10px 40px;
        margin-top: 20px;
      }
    }
  }

  .dashboard_card {
    display: flex;
    flex-wrap: wrap;
    //justify-content: space-between;
    .dashboard_card_item_mar {
      margin-right: 2%;
    }
    .dashboard_card_item {
      width: 32%;
      background: #ffffff;
      box-shadow: 0px 3px 16px 0px rgba(204, 204, 204, 0.3);
      border-radius: 12px;
      margin-top: 30px;
      .dashboard_card_item_top {
        padding: 20px 15px;
        border-radius: 12px 12px 0px 0px;
        display: flex;
        justify-content: space-between;
        .dashboard_card_item_top_title {
          display: flex;
          align-items: center;
        }
        .title_warp {
          font-size: 24px;
          color: #333333;
          margin-left: 10px;
        }
        .dashboard_card_item_top_value {
          font-weight: bold;
          font-size: 50px;
          color: #000000;
          margin-top: 20px;
        }

        .right_ {
          display: grid;
          .right_title {
            font-weight: 300;
            font-size: 16px;
            color: #333333;
          }
          .right_value {
            font-weight: bold;
            font-size: 30px;
            color: #000000;
          }
          .right_margin {
            margin-top: 5px;
          }
        }
      }
      .dashboard_card_item_but {
        padding: 20px 15px;
        display: flex;
        justify-content: space-between;
        .dashboard_card_item_but_item {
          width: 33%;
          display: flex;
          align-items: center;
        }
        .dashboard_card_item_but_item_fg {
          border-right: 1px solid #eeeeee;
          height: 30px;
          width: 1px;
          margin-right: 20px;
        }
        .dashboard_card_item_but_title {
          font-size: 17px;
          color: #999999;
        }
        .dashboard_card_item_but_value {
          font-weight: 500;
          font-size: 20px;
          margin-left: 5px;
        }
        ._j {
          color: #fe4747;
        }
        ._jj {
          color: #53bc5b;
        }
      }
    }
  }
}
</style>
